import * as v from "valibot";

const emailSchema = v.pipe(
  v.string(),
  v.trim(),
  v.email("Введите корректный e-mail."),
);

const passwordSchema = v.pipe(
  v.string(),
  v.minLength(8, "Пароль должен содержать минимум 8 символов."),
);

const consentSchema = v.pipe(
  v.boolean(),
  v.check(Boolean, "Необходимо согласие на обработку данных."),
);

export const loginSchema = v.object({
  email: emailSchema,
  password: passwordSchema,
  consent: consentSchema,
});

export const registrationSchema = v.object({
  firstName: v.pipe(v.string(), v.trim(), v.minLength(2, "Введите имя.")),
  email: emailSchema,
  password: passwordSchema,
  consent: consentSchema,
});

export const resetEmailSchema = v.object({
  email: emailSchema,
});

export const resetOtpSchema = v.object({
  code: v.pipe(
    v.string(),
    v.trim(),
    v.regex(/^\d{6}$/, "Введите 6 цифр из письма."),
  ),
});

export const resetPasswordSchema = v.pipe(
  v.object({
    password: passwordSchema,
    passwordConfirmation: v.pipe(
      v.string(),
      v.minLength(8, "Повторите пароль."),
    ),
  }),
  v.forward(
    v.check(
      (input) => input.password === input.passwordConfirmation,
      "Пароли не совпадают.",
    ),
    ["passwordConfirmation"],
  ),
);
